module.exports = __webpack_public_path__ + "sprite/confetti-0.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/confetti-0.json
// module id = 125
// module chunks = 3